module.exports = __webpack_public_path__ + "files/nvdm.1acfbc790adab28b41ddd0d7e3bd38bf.pdf";